import excelImportComponent from './excel-import.component';

const excelImportModule = angular.module('excel-import', [
])
  .component('excelImport', excelImportComponent)
  .name;

export default excelImportModule;
